export default __webpack_public_path__ + "static/media/obstacle.65ee6fb0.svg";